import { useMemo, useState } from 'react';
import { LessonHeader } from './LessonHeader';
import { primaryBtn, screenShell } from './common';
import { ErrorState, LoadingState } from '../../components/ScreenState';
import { useAsync } from '../../hooks/useAsync';
import { contentApi } from '../../api/content';
import type { LessonScreenProps } from './types';

export function GrammarLessonScreen({ lessonId, unitName, lessonName, onBack, onNext }: LessonScreenProps) {
  const lesson = useAsync(() => contentApi.getLesson(lessonId), [lessonId]);
  const [index, setIndex] = useState(0);

  const items = useMemo(() => (lesson.data ? lesson.data.items.filter((it) => it.itemType === 'GRAMMAR') : []), [lesson.data]);
  const item = items[index];

  if (lesson.loading) return <LoadingState />;
  if (lesson.error || !lesson.data) return <ErrorState message="Không tải được bài học." />;
  if (!item || item.itemType !== 'GRAMMAR') return <ErrorState message="Bài học này chưa có nội dung ngữ pháp." />;

  const next = () => {
    if (index < items.length - 1) setIndex(index + 1);
    else onNext();
  };

  return (
    <div style={screenShell}>
      <LessonHeader onBack={onBack} ctx={{ track: 'grammar', unit: unitName, lesson: lessonName, step: index + 1, total: items.length }} />
      <div style={{ flex: 1, overflowY: 'auto', padding: 24, display: 'flex', flexDirection: 'column', gap: 16 }}>
        <h1 style={{ fontFamily: 'var(--font-jp)', fontSize: 26, fontWeight: 500, textAlign: 'center', color: 'var(--ink)', margin: 0, lineHeight: 1.35 }}>{item.title}</h1>
        {item.meaningVi && <div style={{ fontSize: 16, color: 'var(--text-secondary)', textAlign: 'center' }}>{item.meaningVi}</div>}
        <div style={{ background: 'var(--surface-section)', borderRadius: 'var(--radius-card)', padding: 16, fontSize: 15.5, color: 'var(--ink)', lineHeight: 1.65, whiteSpace: 'pre-wrap' }}>
          {item.bodyMarkdown}
        </div>
      </div>
      <div style={{ padding: 20, borderTop: '1px solid var(--border-default)' }}>
        <button onClick={next} style={primaryBtn}>
          {index < items.length - 1 ? 'Tiếp theo' : 'Hoàn thành'}
        </button>
      </div>
    </div>
  );
}
